// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a310d6ac","224":"a54cb821","239":"5e8e409e","425":"97a57cce","453":"3d391fe9","455":"507ee643","613":"ce1ddf0f","626":"2c0ce7a7","707":"ea462756","839":"bac1facd","870":"ddc87241"}[chunkId] + ".chunk.js";
};